"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonRemovalCoOwnerDisputeKey = exports.CoOwnerDisputeKey = void 0;
var CoOwnerDisputeKey;
(function (CoOwnerDisputeKey) {
    CoOwnerDisputeKey["notOnTitle"] = "notOnTitle";
    CoOwnerDisputeKey["onTheListTwice"] = "onTheListTwice";
    CoOwnerDisputeKey["widowed"] = "widowed";
    CoOwnerDisputeKey["marriedQuitClaim"] = "marriedQuitClaim";
    CoOwnerDisputeKey["separated"] = "separated";
    CoOwnerDisputeKey["deceased"] = "deceased";
})(CoOwnerDisputeKey || (exports.CoOwnerDisputeKey = CoOwnerDisputeKey = {}));
// Dispute options that keep the co-owner as a signer, so they are never sent to the backend.
var NonRemovalCoOwnerDisputeKey;
(function (NonRemovalCoOwnerDisputeKey) {
    NonRemovalCoOwnerDisputeKey["nameMisspelling"] = "nameMisspelling";
    NonRemovalCoOwnerDisputeKey["separatedNoQuitclaim"] = "separatedNoQuitclaim";
    NonRemovalCoOwnerDisputeKey["none"] = "none";
})(NonRemovalCoOwnerDisputeKey || (exports.NonRemovalCoOwnerDisputeKey = NonRemovalCoOwnerDisputeKey = {}));
